import has from 'lodash/has'
import { PERMISSION_ENTITY_INVOICE_OFFER } from '@klear/constants'
import type { CanonicalOrderEventStatusView } from '@klear/order-event-lifecycle/status-view'
import { INVOICE_OFFER_STATUS_LABELS } from '@klear/invoice-offer/presentation'

export type InvoiceOfferLifecycleState = keyof typeof INVOICE_OFFER_STATUS_LABELS
export type InvoiceOfferOrderEventStatusView = CanonicalOrderEventStatusView<
  typeof PERMISSION_ENTITY_INVOICE_OFFER,
  typeof INVOICE_OFFER_STATUS_LABELS
>

export function invoiceOfferOrderEventStatusViewFromCode(status: string): InvoiceOfferOrderEventStatusView | null {
  if (!has(INVOICE_OFFER_STATUS_LABELS, status)) return null
  const lifecycleState = status as InvoiceOfferLifecycleState
  return {
    lifecycleState,
    status: lifecycleState,
    statusLabel: INVOICE_OFFER_STATUS_LABELS[lifecycleState]
  } as InvoiceOfferOrderEventStatusView
}
